import { translation } from 'I18n/i18n'
import AnchorButtonContext from 'contexts/anchorButton'
import CounterContext from 'contexts/counter'
import HeadbandContext from 'contexts/headband'
import Produits from 'pages/salarie/nosClientsNosProduits/produits/produits'
import { useContext, useEffect } from 'react'
import { useSelector } from 'react-redux'
import './gammeProduits.scss'

interface IProps {
   visiteur?:boolean
}

export default function GammeProduits(props: IProps) {
   const lang = useSelector((state: any) => state.languageReducer.language)
   const { setCounter, counterDefault } = useContext(CounterContext)
   const { setHeadband } = useContext(HeadbandContext)
   const { setAnchorButton } = useContext(AnchorButtonContext)
   useEffect(() => {
      setCounter(counterDefault)
      setHeadband(translation(lang, 'gammeProduits', 'title'))
      setAnchorButton([])
   }, [])
   return (
      <div className='scroll'>
         <Produits visiteur={props.visiteur}/>
      </div>
   )
}
